import { useEffect } from 'react';
import { IconLoader4 } from '@tabler/icons-react';
import { useSiteInfo } from '@/SiteInfo/hooks/use-site-info';
import { detectPlatform, getRedirectUrl } from '@/lib/device-redirect';

export default function AppRedirect() {
  const { data: siteInfo, isLoading } = useSiteInfo();

  useEffect(() => {
    if (isLoading || !siteInfo) return;

    const redirectUrl = getRedirectUrl(
      siteInfo.AppStoreURL,
      siteInfo.GooglePlayStoreURL,
      siteInfo.SiteURL
    );

    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [siteInfo, isLoading]);

  const platform = detectPlatform();
  const platformText = platform === 'ios' ? 'App Store' : platform === 'android' ? 'Google Play' : 'website';

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-8">
      <IconLoader4 className="h-8 w-8 animate-spin text-primary mb-4" />
      <p className="text-muted-foreground">
        Redirecting you to the {platformText}...
      </p>
    </div>
  );
}
